import styled from 'styled-components';
import { AUTH_TOKEN_BG } from '../../config/media';

const Wrapper = styled.div`
	padding: 0 50px;

	&.history-wrapper {
		padding: 0px;
	}
	.ant-page-header-heading-sub-title {
		display: block;
		color: #393939;
	}
	.credit-header {
		width: 100%;
		height: 368px;
		overflow: auto;
		background-position: center 60%;
		background-repeat: no-repeat;
		background-size: cover;
		background-image: url(${AUTH_TOKEN_BG});
		display: flex;
		align-items: center;
		.img-logo {
			flex: 1;
			width: 60%;
			margin: auto;
		}
		.payment-header-balance {
			flex: 1;
			margin-left: 5%;
			h2 {
				color: #fff;
				font-size: 44px;
				margin: 0;
			}
			div {
				font-size: 44px;
				color: #fff;
			}
			p {
				color: #fff;
				overflow: visible;
				white-space: nowrap;
				b {
					padding-right: 12px;
				}
			}
		}
		.payment-header-container {
			flex: 1;
			&.flex-area {
				margin-right: 5%;
				display: flex;
				> * {
					font-size: 22px;
					height: auto;
					margin: 0 5px;
				}
			}
		}
	}
	.payment-header {
		width: 100%;
		height: 368px;
		background-position: center 60%;
		background-repeat: no-repeat;
		background-size: cover;
		background-image: url(${AUTH_TOKEN_BG});
		position: relative;
		.img-logo {
			position: absolute;
			width: 30%;
			min-width: 275px;
			max-width: 410px;
			left: 10%;
			top: 50%;
			transform: translateY(-50%);
		}
		.payment-header-balance {
			position: absolute;
			width: 30%;
			left: 10%;
			top: 90px;
			h2 {
				color: #fff;
				font-size: 44px;
				margin: 0;
			}
			div {
				font-size: 44px;
				color: #fff;
			}
			p {
				color: #fff;
				overflow: visible;
				white-space: nowrap;
				b {
					padding-right: 12px;
				}
			}
		}
		.payment-header-container {
			position: absolute;
			right: 124px;
			top: 100px;
			color: #fff;
			width: 350px;
			&.flex-area {
				display: flex;
				width: 500px;
				> * {
					font-size: 22px;
					height: auto;
					margin: 0 5px;
				}
			}
			h3 {
				color: #fff;
				font-size: 32px;
			}
			.select-account {
				.ant-select {
					margin-bottom: 8px;
				}
			}
			.links {
				text-align: center;
				margin-top: 12px;
				span {
					text-decoration: underline;
					color: #0b06de;
					cursor: pointer;
				}
			}
		}
	}
	.credit-info {
		border-bottom: 1px solid #000;
		padding: 34px 0;
		margin: 0 71px;
		h2 {
			font-weight: bold;
		}
		p {
			max-width: 850px;
			margin-bottom: 4px;
		}
		a {
			padding-bottom: 8px;
		}
	}
	.payment-container {
		height: 800px;
		padding: 12px 24px;
		position: relative;
		p {
			margin-bottom: 0;
		}
		h4 {
			font-size: 1.1rem;
			border-top: 1px solid #393939;
			padding-top: 12px;
			margin-bottom: 12px;
		}
		.select-account {
			width: 360px;
			.ant-select {
				margin-bottom: 8px;
			}
		}
	}
	.account-wrapper {
		padding: 24px 71px;
	}

	.learn-container {
		padding: 41px 0;
		margin: 0 71px;
		h2 {
			font-weight: bold;
			margin-bottom: 45px;
		}
		.learn-card {
			padding-left: 300px;
			margin-bottom: 45px;
			position: relative;
			p {
				max-width: 400px;
			}
			.learn-card-image {
				width: 280px;
				height: 100%;
				background-size: cover;
				background-color: #b9b9b9;
				background-repeat: no-repeat;
				background-position: center;
				position: absolute;
				left: 0;
				top: 0;
			}
		}
	}
	@media (max-width: 1200px) {
		.credit-header {
			display: block;
			.payment-header-balance {
				margin-top: 90px;
				h2,
				div {
					font-size: 24px;
				}
				p {
					white-space: initial;
				}
			}
		}
		.payment-header {
			height: 310px;
			padding: 24px;
			text-align: center;
			.img-logo,
			.payment-header-balance,
			.payment-header-container {
				position: static;
				margin: auto;
				text-align: left;
				transform: none;
				min-width: 200px;
			}
			.payment-header-balance,
			.payment-header-container {
				width: 100%;
				h2,
				div {
					font-size: 22px;
				}
				p {
					white-space: normal;
				}
				&.flex-area {
					display: flex;
					width: 100%;
					flex-direction: column;
					> * {
						margin-bottom: 12px;
					}
				}
			}
		}
		.payment-container {
			.select-account {
				width: 100%;
			}
		}
		.credit-info {
			margin: 0 12px;
		}
		.account-wrapper {
			padding: 16px;
		}
		.learn-container {
			margin: 0 12px;
			.learn-card {
				padding-left: 0;

				.learn-card-image {
					position: static;
					width: 100%;
					height: 150px;
				}
			}
		}
	}
	@media (max-width: 960px) {
		.payment-header {
			.payment-header-balance,
			.payment-header-container {
				p {
					overflow: auto;
				}
			}
		}
	}
	@media (max-width: 960px) {
		padding: 0 12px;
	}
`;
export const TitleWrapper = styled.div`
	.title-wrapper {
		display: flex;
		align-items: center;
		font-size: 14px;
		.title {
			font-size: 24px;
		}
		.coin-wrap {
			margin: 0 5px 0 15px;
		}
	}
`

export const DepositModalWrapper = styled.div`
	.deposit-modal {
		.title-wrapper {
			display: flex;
			align-items: center;
			font-size: 14px;
			.title {
				font-size: 24px;
			}
			.coin-wrap {
    			margin: 0 5px 0 15px;
			}
		}
	}
	.select-wrapper {
		margin: 1rem 0 2rem 0;
   		color: #000000;
		.ant-select {
			width: 90%;
			margin-top: .5rem;
		}
		.warning-wrapper {
			display: flex;
			font-size: 12px;
			color: #FF0000;
			margin-top: 10px;
			.anticon {
   	 			margin: 2px 5px 0 0;
			}
		}
	}
	.btn-wrapper {
		margin-top: 1rem;
		.ant-btn {
			width: 100%;
		}
	}
	
`

export const WithdrawWrapper = styled.div`
	.input-container {
		padding: 12px 0;
		.btn-max {
			color: #00f;
			cursor: pointer;
		}
		.max-info {
			position: relative;
			padding-left: 22px;
			padding-top: 8px;
			font-size: 12px;
			color: #b9b9b9;
			.anticon-info-circle {
				position: absolute;
				top: 11px;
				left: 3px;
			}
		}
		.warn-text {
			display: flex;
			font-size: 12px;
			color: #FF0000;
			margin-top: 10px;
			.anticon {
   	 			margin: 2px 5px 0 0;
			}
		}
	}
	.confirm {
		font-size: 24px;
		font-weight: bold;
	}
	.confirm-box {
		margin: 14px 0;
		padding: 12px 24px;
		box-sizing: border-box;
		background-color: #f9f9f9;
		text-align: center;
	}
	.caution {
		font-size: 19px;
		color: #f28041;
		font-weight: bold;
		padding-top: 14px;
	}
	p {
		margin-bottom: 0;
	}
	.btn-wrapper {
        display: flex;
        margin-top: 1rem;
        .ant-btn {
            flex: 1
        }
        .separator {
            margin: 5px;
        }
        .ant-btn-primary {
            color: #fff;
            background-color: #3A4FFF;
            border-color: #3A4FFF;
        }
        .ant-btn-primary:disabled {
            color: #fff;
            background-color: #42454D;
            border-color: #42454D;
        }
    }
	.ant-input-group > .ant-input:last-child, .ant-input-group-addon:last-child {
    background: #212121;
    border:1px solid #fff;
}
	@media (max-width: 1200px) {
	}
`;

export const DescriptionWrapper = styled.div`
	padding: 24px 0px;
	width: 100%;
	.title-description {
		display: flex;
		justify-content: space-between;
    	margin-top: 1rem;
	}
	.table-wrap {
		.ant-table-thead > tr > th,
		.ant-table-tbody > tr > td {
    		width: 30%;
		}
		.flex-col {
			display: flex;
			align-items: center;
		}
		.coin-wrap {
			margin-right: 5px;
		}
	}
	.history-title {
		font-size: 18px;
		font-weight: bold;
		padding-left: 3rem;
		border-bottom: 1px solid #A8A8B1;
	}
	@media (max-width: 960px) {
		.title-description {
			flex-direction: column;
			margin: 0;
		}
		.filter-wrapper {
			margin-bottom: 1rem;
		}
		.table-wrap {
			overflow-x: auto;
		}
	}
`;

export const StakedXHTContainer = styled.div`
	padding: 24px 0px;
	width: 100%;
	.d-flex {
		display: flex;
	}
	.xht-icon {
		width: 40px;
		margin-right: 5px;
	}
	.xht-icon-large {
		width: 70px;
		margin-right: 5px;
	}
	.title {
		font-size: 22px;
		font-weight: bold;
		color: #000000;
	}
	.sub-title {
		font-size: 18px;
		font-weight: bold;
		color: #000000;
	}
	.sub-title-wrapper {
		margin-left: 2rem;
	}
	.anchor {
		color: #5985ff;
		text-decoration: underline;
		cursor: pointer;
	}
	.sub-content {
		margin: 2rem 0;
		.table-container {
			margin: 1rem 0;
		}
		.box {
			width: 370px;
			background-color: #F4F4F4;
			padding: 1rem 2rem;
			margin-top: 1rem; 
			span {
				font-weight: bold;
			}
			.black-txt {
				color: #000000;
			}
		}
		.box-align {
			margin-left: 2rem;
		}
		.total-wrapper {
			display: flex;
		}
	}
	.progress-bar {
		height: 15px;
		width: 100%;
		margin: 3px 0px 0px 5px;
		background-color: #C7C7C7;
		.progress-bar-blue {
			background-color: #0000FF;
		}
	}
	.name-column {
		img {
			width: 20px;
		}
	}
	@media (max-width: 960px) {
		.sub-content {
			.total-wrapper {
				flex-direction: column;
			}
			.box {
				width: 100%;
			}
			.box-align {
				margin-left: 0;
			}
			.table-container {
				overflow-x: scroll;
			}
		}
	}
`;

export default Wrapper;
